import type { Parameters } from './root-stack';

export function isListingOpenedFromMap(params: Parameters['listingModal'] | undefined) {
  if (params?.screen !== 'one-listing') return false;
  return params.params?.hideApproximateLocation === true;
}
